import { render, staticRenderFns } from "./MedicineItem.vue?vue&type=template&id=651b58d8"
import script from "./MedicineItem.vue?vue&type=script&lang=js"
export * from "./MedicineItem.vue?vue&type=script&lang=js"
import style0 from "./MedicineItem.vue?vue&type=style&index=0&id=651b58d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports